import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  ACTIVATION,
  LIST_ACTIVATION,
  LIST_COMMENTAIRE,
} from "../../Utils/constant";
import ok from "../../assets/images/ok.png";
import { updateOne } from "../../services/service";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreLivraison } from "../../store/livraisonStore";
import { SubmitButton } from "../Widget/SubmitButton";
export const UpdateActivation = ({ numeroTicket, setActive }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const commentaire = useCommentaireStore();
  const store = useStoreLivraison();

  const submit = (data) => {
    const requestData = {
      ...data,
      status: "REALISER",
      numeroTicket: numeroTicket,
    };
    setIsSubmit(true);
    updateOne(ACTIVATION, "", requestData)
      .then((res) => {
        if (res.status === 200) {
          setActive({ index: 0, value: "" });
          toast.success("Rendez-vous de survey éffectuée");
          setIsSubmit(null);
          document.getElementById("fermer").click();
          store.getData(
            LIST_ACTIVATION,
            { page: 0, param: "", size: 10 },
            "&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=OK"
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };

  useEffect(() => {
    commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, "");
  }, []);

  return (
    <>
      {isSubmit !== null ? (
        <form className="px-2" onSubmit={handleSubmit(submit)}>
          <div className="my-4 space-y-4">
            <div className="my-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text text-sm font-semibold">
                    Resultat de l'activation{" "}
                    <span className="text-red-500">*</span>
                  </span>
                </div>
                <select
                  {...register("resultat", { required: true })}
                  className="select select-bordered w-full"
                >
                  <option disabled>Selectionnez un status</option>
                  <option value={"OK"}>OK</option>
                  <option value={"NON_OK"}>Non OK</option>
                  <option value={"PARTIALY_OK"}>Partialy OK</option>
                </select>
              </label>
            </div>

            <div className="my-2">
              <label className="form-control w-full">
                <div className="label -mb-1">
                  <span className="label-text font-medium text-gray-400">
                    Type commentaire <span className="text-red-500">*</span>
                  </span>
                </div>
                <select
                  {...register("typeCommentaire", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} disabled>
                    Selectionnez un type
                  </option>
                  {commentaire?.data?.data?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
              </label>
            </div>

            <div className="my-2">
              <label htmlFor="" className="text-sm font-medium">
                Commentaire
              </label>
              <textarea
                {...register("commentaire")}
                placeholder="Votre commentaire"
                className="textarea textarea-bordered textarea-sm w-full"
              ></textarea>
            </div>
            <div className="w-full">
              <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
            </div>
          </div>
        </form>
      ) : (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={ok} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Activation de la ligne effectuée
            </p>
          </div>
        </div>
      )}
    </>
  );
};
